import { useQuery, UseQueryResult } from 'react-query';
import companyService from '../../services/companyService';
import { ICompany } from '../../shared/interfaces/company-interfaces';
import { IService } from '../../shared/interfaces/service-interfaces';

enum ServiceKeys {
  detailCompany = 'detailCompany',
  listCompanyServices = 'listCompanyServices',
}

const fetchCompanyDetail = async (slug: string) => {
  const response = await companyService.detail(slug);

  return response.data;
};

const fetchCompanyServicesBySlug = async (slug: string) => {
  const response = await companyService.listServicesBySlug(slug);

  return response.data;
};

export const useGetCompanyDetail = (slug: string): UseQueryResult<ICompany> => {
  return useQuery(ServiceKeys.detailCompany, () => fetchCompanyDetail(slug), {
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    retry: 2,
    enabled: !!slug,
  });
};
export const useGetCompanyServices = (
  slug: string,
): UseQueryResult<IService[]> => {
  return useQuery(
    [ServiceKeys.listCompanyServices, slug],
    () => fetchCompanyServicesBySlug(slug),
    {
      staleTime: 1000 * 60 * 3,
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  );
};
